import React, {useEffect, useState} from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
//import "bootstrap/dist/css/bootstrap.css";
import "./../../Public/css/tabler-icons.css";
import "./../../Public/css/fontawesome.min.css";
import "./../../Public/css/all.min.css";
import "./../../Public/css/style.css";
import logo from "./../../Public/img/logo-black.png";
import { ToastContainer } from 'react-toastify';
import {successMesg, errorMesg} from "./../Toaster";
import {resetPasswordAPI} from "./../../API/AuthenticationAPI";

const ResetPassword = () =>{

    const {token} = useParams();
    const navigate = useNavigate();
    const [btnloading, setBtnLoading] = useState(false);
    const [newpassword, setNewpassword] = useState("");
    const [confirmpassword, setConfirmpassword] = useState("");

    const handleNewpassword = (event) =>{
        setNewpassword(event.target.value);
    }

    const handleConfirmPassword = (event) =>{
        setConfirmpassword(event.target.value);
    }

    const handleChangePassword = (e) =>{
        e.preventDefault();

        if(newpassword === "")
        {
            errorMesg("Please enter new password");
        }
        else if(confirmpassword === "")
        {
            errorMesg("Please enter confirm password");
        }
        else if(newpassword !== confirmpassword)
        {
            errorMesg("New password does not match with confirm password");
        }
        else
        {
            const params = {
                            token: token,
                            newpassword: newpassword,
                            confirmpassword: confirmpassword
            };

            resetPasswordAPI(params, setBtnLoading, navigate);
        }
    }



    return(
        <div className="account-page">
            <div className="main-wrapper">
                <div className="account-content">
                    <div className="w-100 vh-100 overflow-hidden auth-wrapper basic-auth">
                        <div className="auth-inner">
                            <div className="card__wrapper overflow-auto">
                                <form action="#" className="flex-fill">
                                    <div className="mx-auto mw-450">
                                        <div className="text-center mb-4 img-logo">
                                            <img src={logo} className="img-fluid" alt="Logo" />
                                        </div>
                                        <div className="mb-4 text-center">
                                            <h4 className="mb-2 fs-20">Reset Password</h4>                                            
                                        </div>
                                        <div className="mb-3">
                                            <label className="col-form-label">New Password</label>
                                            <div className="pass-group">
                                                <input type="password" className="pass-input form-control" name="newpassword" value={newpassword} onChange={handleNewpassword} />
                                                <span className="ti toggle-password ti-eye-off"></span>
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <label className="col-form-label">Confirm Password</label>
                                            <div className="pass-group">
                                                <input type="password" className="pass-input form-control" name="confirmpassword" value={confirmpassword} onChange={handleConfirmPassword} />
                                                <span className="ti toggle-password ti-eye-off"></span>
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <button type="button" className="btn btn-primary w-100" onClick={handleChangePassword}>
                                                {btnloading ?
                                                    <div className="spinner-border" role="status">
                                                        <span className="sr-only">Loading...</span>
                                                    </div>
                                                :
                                                    <p>Change Password</p>
                                                }
                                            </button>
                                        </div>
                                        <div className="mb-3 text-center">
                                            <h6>Return to?  
                                                <Link to="/sign-in"  className="text-purple link-hover">Login</Link>
                                            </h6>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </div>
    )
}

export default ResetPassword;